'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (app) {
  app.provider('httpInterceptors', function () {

    var self = this;

    self.webKey = '';
    self.EVENTS = {
      tokenExpired: 'tokenExpired'
    };

    self.interceptor = function ($rootScope, $q) {
      return {
        request: function request(config) {
          config.timeout = 30000;
          return config;
        },
        responseError: function responseError(rejection) {
          if (!rejection.data) {
            rejection.data = {};
          }
          var message = '';
          switch (rejection.status) {
            case -1:
              {
                // 远程服务器无响应
                break;
              }
            case 401:
              {
                // token 过期 刷新
                $rootScope.$emit(self.EVENTS.tokenExpired, rejection.config);
                break;
              }
            case 408:
              {
                message = '请检查您的网络，重新加载';
                break;
              }
            default:
              {
                if ((0, _objectType.isString)(rejection.data)) {
                  message = rejection.data;
                } else {
                  message = rejection.data['Message'] || '请求失败，请联系客服';
                }
              }
          }
          return $q.reject({ message: message });
        }
      };
    };

    // 注入服务
    self.interceptor['$inject'] = ['$rootScope', '$q'];

    self.$get = function () {
      return {
        EVENTS: {
          tokenExpired: self.EVENTS.tokenExpired
        }
      };
    };

    return self;
  });
  return app;
};

require('angular');

var _objectType = require('../../utils/objectType');

; /**
   * http interceptors
   * $http 服务拦截器
   */


//////////////////
// WEBPACK FOOTER
// ./src/lib/angular1.x-common/services/httpInterceptors.js
// module id = 148
// module chunks = 0